import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-absensi-dialog',
  templateUrl: './absensi-dialog.component.html',
  styleUrls: ['./absensi-dialog.component.scss']
})
export class AbsensiDialogComponent implements OnInit {

  // @Input() dateandtime : string;
  // @Input() coordinates : {
  //   latitude : number,
  //   longitude: number
  // };
  timeOut = 10000;
  countDown = 10;
  myInterval;

  constructor(
    protected ref : NbDialogRef<AbsensiDialogComponent>
  ) { }

  ngOnInit(): void {
   this.myInterval = setInterval(() => {
    this.countDown -= 1;
    this.closeOnTimeOut(this.countDown);
   }, 1000);
  }
  
  closeOnTimeOut(timeLeft) {
    if(timeLeft <= 0) {
      this.close();
    }
    return;
  }

  close() {
    this.ref.close({event : false});
    clearInterval(this.myInterval);
  }

  proceed() {
    this.ref.close({event: true});
    clearInterval(this.myInterval);
  }

}
